var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlinds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H39V42H9V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8V39H12V8H9V39V42H12H36H39V39V8H36Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.15789H44V9.94737H4V9.15789ZM4 11H44V10.2105H4V11ZM4 7.84211H44V7.05263H4V7.84211ZM4 6V6.78947H44V6H4ZM4 8.89474H44V8.10526H4V8.89474Z",
    fill: "#EE8003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 12C43 12.6 42.6 13 42 13C41.4 13 41 12.6 41 12C41 11.4 41.4 11 42 11C42.6 11 43 11.4 43 12ZM42 14C41.4 14 41 14.4 41 15C41 15.6 41.4 16 42 16C42.6 16 43 15.6 43 15C43 14.4 42.6 14 42 14ZM42 17C41.4 17 41 17.4 41 18C41 18.6 41.4 19 42 19C42.6 19 43 18.6 43 18C43 17.4 42.6 17 42 17ZM42 24C43.1 24 44 23.1 44 22C44 20.9 43.1 20 42 20C40.9 20 40 20.9 40 22C40 23.1 40.9 24 42 24Z",
    fill: "#9FA8DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlinds);
export default __webpack_public_path__ + "static/media/blinds.e1cb48e844eb926ca3f5a9000d087439.svg";
export { ForwardRef as ReactComponent };